import { reducerWrapper } from '../support/utils';
import { QUICK_LINK_COUNT, GET_ALL_QUICK_LINKS } from '../actions/QuickLinksActions';

const INIT_STATE = {
  loading: false,
  error: null,
  data: null,
  link_count: 0,
  links: [],
};

function Handler(state, action) {
  switch (action.type) {
    case QUICK_LINK_COUNT.response:
      return { ...state, link_count: action.data };

    case GET_ALL_QUICK_LINKS.response:
      return { ...state, links: action.data };

    default:
      return state;
  }
}

const QuickLinksReducer = reducerWrapper(INIT_STATE, Handler, {
  request: [QUICK_LINK_COUNT, GET_ALL_QUICK_LINKS],
  error: [QUICK_LINK_COUNT, GET_ALL_QUICK_LINKS],
  resetOn: ['APP_CHANGE'],
});
export default QuickLinksReducer;
